import { io } from "socket.io-client";

const base = import.meta.env.BASE_URL;

const socketon = io(window.location.origin, {
  path: `${base}socket.io`,
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  timeout: 10000,
});

const socketoff = () => {
  socketon.disconnect();
};

export { socketon, socketoff };